

export const normalizeTextSms = (text: string, replacedFor: string = "-", replacePolishLetters: boolean = true): string => {
  let t = text;
  let r = replacedFor;


  t = t.split("\n").join("**")
  t = t.split("/").join("!!")
  t = t.split("?").join("@@")
  t = t.split("_").join("##")

  //t = t.split("&").join(r)
  //t = t.split("|").join(r)
  //t = t.split("+").join(r)
  //t = t.split("=").join(r)

  if (replacePolishLetters) {
    t = t.replace(/ę/ig, 'e');
    t = t.replace(/ż/ig, 'z');
    t = t.replace(/ó/ig, 'o');
    t = t.replace(/ł/ig, 'l');
    t = t.replace(/ć/ig, 'c');
    t = t.replace(/ś/ig, 's');
    t = t.replace(/ź/ig, 'z');
    t = t.replace(/ń/ig, 'n');
    t = t.replace(/ą/ig, 'a');

    t = t.replace(/Ę/ig, 'E');
    t = t.replace(/Ż/ig, 'Z');
    t = t.replace(/Ó/ig, 'O');
    t = t.replace(/Ł/ig, 'L');
    t = t.replace(/Ć/ig, 'C');
    t = t.replace(/Ś/ig, 'S');
    t = t.replace(/Ź/ig, 'Z');
    t = t.replace(/Ń/ig, 'N');
    t = t.replace(/Ą/ig, 'A');
  }

  return t
}

